module.exports = __webpack_public_path__ + "static/books-9d36065aeda814c7646726a15796aa5f.png";